import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import Input from '../common/Input';
import Spinner from '../common/Spinner';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="auth-form fade-in">
      <h1 className="auth-title">Welcome Back</h1>
      {error && <div className="error-message">{error}</div>}
      <Input label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
      <Input label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
      <Button type="submit" className="full-width" disabled={loading}>
        {loading ? <Spinner /> : 'Sign In'}
      </Button>
      <style>{`
        .auth-form {
          width: 100%;
          max-width: 400px;
          margin: 0 auto;
          animation: fadeIn 0.5s ease;
        }
        .auth-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 2rem;
          color: var(--text);
        }
        .error-message {
          background: #fee2e2;
          color: #991b1b;
          padding: 0.75rem;
          border-radius: var(--radius-sm);
          margin-bottom: 1rem;
        }
        .full-width {
          width: 100%;
          margin-top: 1rem;
        }
      `}</style>
    </form>
  );
};
export default LoginForm;